module.exports = __webpack_public_path__ + "img/top-function-prediction.537ca25e.jpg";